import { useState } from 'react'
import { useAuth } from './AuthContext'

export default function LoginPage() {
  const { signIn } = useAuth()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [showPassword, setShowPassword] = useState(false)
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    setLoading(true)
    try {
      await signIn(email, password)
    } catch (err) {
      setError(
        err.message?.includes('Invalid')
          ? 'Invalid email or password.'
          : `Sign-in failed: ${err.message}`
      )
    } finally {
      setLoading(false)
    }
  }

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'linear-gradient(135deg, #9333ea, #8b5cf6, #f59e0b)', padding: '1rem',
      fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
    }}>
      <div style={{
        background: '#fff', borderRadius: '1.5rem', padding: '2.5rem',
        width: '100%', maxWidth: '420px', boxShadow: '0 25px 50px rgba(0,0,0,0.15)'
      }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
          <img src="/agi-logo.jpeg" alt="AGI" style={{ height: '64px', objectFit: 'contain' }} />
        </div>

        <h1 style={{
          textAlign: 'center', fontSize: '1.75rem', fontWeight: 700,
          color: '#1e3a5f', marginBottom: '0.25rem'
        }}>
          Cable Config
        </h1>
        <p style={{
          textAlign: 'center', color: '#64748b', fontSize: '0.875rem', marginBottom: '2rem'
        }}>
          Sign in to access the cable configurator
        </p>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '1.25rem' }}>
            <label style={{
              display: 'block', fontSize: '0.875rem', fontWeight: 600,
              color: '#334155', marginBottom: '0.375rem'
            }}>
              Email address
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@agiusa.com"
              required
              style={{
                width: '100%', padding: '0.75rem 1rem', border: '1px solid #cbd5e1',
                borderRadius: '0.5rem', fontSize: '0.875rem', outline: 'none',
                boxSizing: 'border-box'
              }}
            />
          </div>

          <div>
            <label style={{
              display: 'block', fontSize: '0.875rem', fontWeight: 600,
              color: '#334155', marginBottom: '0.375rem'
            }}>
              Password
            </label>
            <input
              type={showPassword ? 'text' : 'password'}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              required
              style={{
                width: '100%', padding: '0.75rem 1rem', border: '1px solid #cbd5e1',
                borderRadius: '0.5rem', fontSize: '0.875rem', outline: 'none',
                boxSizing: 'border-box'
              }}
            />
            <div style={{
              display: 'flex', alignItems: 'center', justifyContent: 'space-between',
              marginTop: '0.5rem', marginBottom: '1.25rem'
            }}>
              <label style={{
                display: 'flex', alignItems: 'center', gap: '0.5rem',
                fontSize: '0.875rem', color: '#64748b', cursor: 'pointer'
              }}>
                <input
                  type="checkbox"
                  checked={showPassword}
                  onChange={(e) => setShowPassword(e.target.checked)}
                />
                Show password
              </label>
              <button type="button" style={{
                fontSize: '0.875rem', color: '#2563eb', background: 'none',
                border: 'none', cursor: 'pointer', textDecoration: 'none'
              }}
                onMouseOver={(e) => e.target.style.textDecoration = 'underline'}
                onMouseOut={(e) => e.target.style.textDecoration = 'none'}
              >
                Forgot your password?
              </button>
            </div>
          </div>

          {error && (
            <div style={{
              background: '#fef2f2', color: '#dc2626', padding: '0.75rem',
              borderRadius: '0.5rem', fontSize: '0.875rem', marginBottom: '1rem',
              border: '1px solid #fecaca'
            }}>
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%', padding: '0.75rem',
              background: 'linear-gradient(to right, #1d4ed8, #10b981)',
              color: '#fff', fontWeight: 600, border: 'none', borderRadius: '0.5rem',
              fontSize: '0.875rem', cursor: loading ? 'not-allowed' : 'pointer',
              opacity: loading ? 0.5 : 1
            }}
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        <div style={{
          marginTop: '2rem', paddingTop: '1.5rem', borderTop: '1px solid #e2e8f0',
          textAlign: 'center'
        }}>
          <p style={{ color: '#94a3b8', fontSize: '0.8rem' }}>Need help?</p>
          <p style={{ color: '#64748b', fontSize: '0.8rem', marginTop: '0.25rem' }}>
            support@agiusa.com | 1.512.335.3338
          </p>
        </div>
      </div>
    </div>
  )
}
